<div id="chartContainer" #chartContainer style="width: 100%;"></div>